import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'
import moment from 'moment'
import tinymce from 'tinymce'
import Vant from 'vant'
import 'vant/lib/index.css'
import './core/boot'
import { formatErrorTxt } from '@/utils/tool'

import AsyncTask from './components/AsyncTask/index'
import ExpireTip from './components/ExpireTip/index'

// 修改皮肤文件路径
import 'tinymce/skins/ui/oxide/skin.min.css'
// import 'tinymce/skins/content/default/content.min.css'

// 主题
import 'tinymce/themes/silver'

// 插件
import 'tinymce/plugins/link' // 链接插件
import 'tinymce/plugins/image' // 图片插件
import 'tinymce/plugins/media' // 媒体插件
import 'tinymce/plugins/table' // 表格插件
import 'tinymce/plugins/lists' // 列表插件
import 'tinymce/plugins/quickbars' // 快速栏插件
import 'tinymce/plugins/fullscreen' // 全屏插件
import 'tinymce/plugins/paste' // 粘贴插件

/**
 * 注：
 * 5.3.x版本需要额外引进图标，没有所有按钮就会显示not found
 */
import 'tinymce/icons/default/icons'

// 本地化
import './utils/tinymce/langs/zh_CN.js'
import './utils/tinymce/langs/zh_TW.js'
import './utils/tinymce/langs/ko_KR.js'
import './utils/tinymce/langs/ja.js'

import xss from 'xss'
import i18n from './i18n'
import { prettyLog } from '@/utils/pretty'

Object.defineProperty(Vue.prototype, '$xss', {
  value: xss
})
Vue.prototype.$tinymce = tinymce
VueClipboard.config.autoSetContainer = true
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.use(VueClipboard)
Vue.use(ElementUI)
Vue.use(AsyncTask)
Vue.use(ExpireTip)
Vue.use(Vant)

Vue.config.productionTip = true
Vue.prototype.$EventBus = new Vue()
Vue.prototype.moment = moment
Vue.prototype.$prettylog = prettyLog
Vue.prototype.$axios = axios
Vue.prototype.$formatErrorTxt = formatErrorTxt

Vue.component('OutJs', {
  props: {
    jsUrl: {
      type: String,
      required: true
    }
  },
  render(createElement) {
    const _self = this
    return createElement('script', {
      attrs: {
        type: 'text/javascript',
        src: this.jsUrl
      },
      on: {
        load(event) {
          _self.$emit('load', event)
        }
      }
    })
  }
})

/** ************初始化**************** */
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
